<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="modalTitle">Kalkulasi Ongkos Kirim</h4>
        <div class="modalSc">
          <div class="from">
            Dikirim dari <b v-if="product && product.warehouse">
              {{product.warehouse.cityName}}
            </b> ke:
          </div>
          <div class="addressCnt" v-if="address">
            <div class="addressItem">
              <div class="addressLabel">{{address.label}}</div>
              <h4>{{address.recipient}} <span>({{address.phone}})</span></h4>
              <div class="addrNotes" v-if="address.notes && address.notes !== ''">
                {{address.notes}}
              </div>
              <div class="theAddress">
                <p>{{address.userAddress}}<span
                  v-if="address.rtrw">, RT/RW {{address.rtrw}}</span><span
                  v-if="address.subDistrict">, Desa {{address.subDistrict}}</span><span
                  v-if="address.district">, Kec. {{address.district}}</span><span
                  v-if="address.cityName">, Kota {{address.cityName}}</span><span
                  v-if="address.provinceName">, Provinsi {{address.provinceName}}</span><span
                  v-if="address.postalCode"> - {{address.postalCode}}</span></p>
              </div>
            </div>
          </div>
          <div class="adressAction">
            <button class="btn secondary" v-on:click="addAddress">Tambah Alamat Baru</button>
            <button class="btn secondary" v-if="address"
              v-on:click="showAddress">Pilih Alamat Lain</button>
          </div>
          <div class="from from2">Pilihan kurir tersedia:</div>
          <div v-if="loadingCourier" class="loadingCourier"></div>
          <div v-else>
            <div class="deliveryInfo" v-for="(c, i) in couriers" :key="`cor${i}`">
              <div class="courierItem">
                <div class="courierLogo" :class="c.code"></div>
                {{c.name}}
              </div>
              <div class="courierPrice" v-for="(cost, i2) of c.costs" :key="`cos${i2}`">
                <template v-if="cost.cost.length > 0">
                  {{cost.description}} ({{cost.service}}) - ETD: {{cost.cost[0].etd}}
                  <span v-if="cost.cost[0].value">
                    Rp {{cost.cost[0].value.toLocaleString('id')}}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Address ref="address"/>
      <AddAddress ref="addAddress"/>
    </div>
  </transition>
</template>

<script>
import Address from '@/components/Address.vue';
import AddAddress from '@/components/AddAddress.vue';

export default {
  name: 'calcDelivery',
  components: { Address, AddAddress },
  data() {
    return {
      show: false,
      loading: true,
      item: null,
      next: null,
      loadingCourier: false,
      address: null,
      product: null,
      couriers: [],
    };
  },
  methods: {
    open(d, n) {
      this.product = d.product;
      this.address = d.address;
      this.couriers = d.couriers;
      this.loadingCourier = false;
      this.next = n;
      this.show = true;
    },
    close(b) {
      this.show = false;
      if (this.next) this.next(b);
    },
    addAddress() {
      this.$refs.addAddress.open(null, (b, v) => {
        if (!b) return;
        this.address = v;
        this.getCourier();
      });
    },
    showAddress() {
      this.$refs.address.open(null, (b, v) => {
        if (!b) return;
        this.address = v;
        this.getCourier();
      });
    },
    getCourier() {
      this.loadingCourier = true;
      this.$http.post(this.$config.uri('misc/courier/available'), {
        addressId: this.address.id,
        productId: this.product.id,
      }).then((r2) => {
        this.loadingCourier = false;
        this.couriers = (r2.data.status === 200) ? r2.data.data : [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      overflow: hidden;
      width: 480px;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      min-height: 40px;
      @media (max-width: 680px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 30px 20px;
      }
      .modalSc{
        max-height: calc(100vh - 300px);
        overflow-y: auto;
        padding: 10px 40px 20px;
        margin: 0 -40px -10px;
        border-bottom: #eee 1px solid;
        box-sizing: border-box;
      }
      h4.modalTitle{
        margin: 0 -40px;
        padding: 0 40px 10px;
        font-size: 24px;
        font-weight: normal;
        color: #444;
        border-bottom: #eee 1px solid;
      }
      .from{
        margin: 10px 12px;
        &.from2{
          margin-top: 20px;
        }
      }
      .addressCnt{
        padding-bottom: 10px;
        .addressItem{
          border-radius: 5px;
          border: #ddd 1px solid;
          padding: 12px 16px;
          .addrNotes{
            padding: 4px 10px;
            background-image: linear-gradient(to right, #fae502, transparent);
            display: inline-block;
            border-radius: 3px;
            margin: 4px 0 6px;
            padding-left: 30px;
            position: relative;
            &:before{
              content: "";
              position: absolute;
              left: 6px; top: 2px; bottom: 2px; width: 20px;
              background-image: url(../assets/notes.png);
              background-size: 16px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
          .addressLabel{
            font-size: 13px;
            font-weight: 800;
            color: #858585;
            margin: 0 0 4px;
            text-transform: uppercase;
          }
          h4{
            margin: 0 0 4px;
            font-size: 16px;
            font-weight: 600;
          }
          .theAddress{
            font-size: 14px;
            p{
              margin: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .adressAction{
        .btn{
          font-size: 15px;
          border: #035fae 1px solid;
          padding: 8px 14px;
          margin-right: 10px;
          margin-bottom: 5px;
        }
      }
      .loadingCourier{
        height: 200px;
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 46px auto;
      }
      .deliveryInfo{
        margin-bottom: 10px;
        border: #eee 1px solid;
        border-radius: 5px;
        padding: 12px 20px 4px;
        .courierItem{
          font-size: 15px;
          position: relative;
          display: flex;
          align-items: center;
          margin: 0 -20px;
          padding: 0 20px 8px;
          border-bottom: #eee 1px solid;
          .courierLogo{
            width: 30px; height: 20px;
            background-color: #fff;
            margin-right: 10px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            &.jne{
              background-image: url(../assets/courier/courier-jne.png);
            }
            &.pos{
              background-image: url(../assets/courier/courier-pos.png);
            }
            &.tiki{
              background-image: url(../assets/courier/courier-tiki.png);
            }
          }
          &.more{
            color: #035fae;
            font-weight: 600;
            margin-top: 10px;
            font-size: 14px;
            cursor: pointer;
            transition: all .3s ease;
            &:hover{ color: #002f5f; }
          }
        }
        .courierPrice{
          display: flex;
          font-size: 14px;
          border-bottom: #ccc 1px dashed;
          padding: 10px 0;
          &:last-child{
            border: none;
          }
          span{
            margin-left: auto;
            font-weight: 600;
            white-space: nowrap;
            display: inline-block;
            padding-left: 20px;
          }
        }
      }
    }
  }
</style>
